import React, {Component} from "react";


class NotFoundPage extends Component{
    render(){
        return (
            <div>
                <h2>Page not found!</h2>
            </div>
        )
    }
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js